import {ColorFillPropertyType} from '@Components/color-fill';

export enum ColorTypeTab {
  SOLID = 'solid',
  GRADIENT = 'gradient',
}

export const DEFAULT_GRADIENT_TYPE = ColorFillPropertyType.LINEAR;
/** Tab key of no tab: shown while the items disagree on fill type. */
export const NO_SELECTED_TAB_KEY = '';

export interface ColorTypeTabData {
  id: ColorTypeTab;
  text: string;
  /** Doubles as the tab key: the design-system Tabs render it as the tab's data-testid. */
  testId: string;
}

export interface ColorTypeTabsProps {
  type: ColorFillPropertyType;
  /** When true the items disagree on fill type: no tab is active. */
  isTypeMixed: boolean;

  onChangeType(type: ColorFillPropertyType): void;
}
